import { Injectable } from '@angular/core';
import { TranslationLocalService } from 'gung-standard';
import seTranslations from '../../i18n/se.json';
import enTranslations from '../../i18n/en.json';
import { HttpClient, HttpBackend } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RefTranslationLocalService extends TranslationLocalService {
  constructor(protected http: HttpClient, protected handler: HttpBackend) {
    super(http, handler);
  }

  protected async getCustTranslations(lang: string): Promise<any> {
    if (lang === 'se') {
      return seTranslations;
    }
    if (lang === 'en') {
      return enTranslations;
    }
    return {};
  }
}
